import type { PlannedMeal, Recipe } from '../types';

/** Attach live recipe data to a planned meal, keeping a stable cached name when the recipe doc is still loading. */
export function attachRecipeToPlannedMeal(
    plannedMeal: PlannedMeal,
    recipes: Recipe[],
    unknownRecipeLabel: string,
): PlannedMeal & { recipe: Recipe } {
    const matched = recipes.find((recipe) => recipe.id === plannedMeal.recipeId);
    if (matched) {
        return { ...plannedMeal, recipe: matched };
    }

    const cachedName = plannedMeal.recipeName?.trim();
    return {
        ...plannedMeal,
        recipe: {
            id: plannedMeal.recipeId,
            name: cachedName || unknownRecipeLabel,
            ingredients: [],
            instructions: '',
            servings: plannedMeal.plannedServings,
            links: [],
            isPublic: false,
            ownerId: '',
            householdId: '',
            isDeleted: !cachedName,
        },
    };
}
